import { Helpers } from '../../helpers';
import { IItemCategory } from '../../interfaces/iitem-category';
import { Item } from '../item';
import { ItemRate } from '../item-rate';
import { ItemSubCategory } from '../item-sub-category';
import { ProjectResourceItem } from '../project-resource-item';
import { ProjectResourceItemsRevision } from '../project-resource-items-revision';
import { ResourceCalculation } from '../resource-calculation';
import { ResourceCategory } from '../resource-category';

export class ItemCategoryBase {
  ItemCategoryId: number;
  ItemCategoryName: string;
  Source: string | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  ItemRates_ItemCategory?: Array<ItemRate> | null;
  Items_ItemCategory?: Array<Item> | null;
  ItemSubCategories_ItemCategory?: Array<ItemSubCategory> | null;
  ProjectResourceItems_ItemCategory?: Array<ProjectResourceItem> | null;
  ProjectResourceItemsRevisions_ItemCategory?: Array<ProjectResourceItemsRevision> | null;
  ResourceCalculations_ItemCategory?: Array<ResourceCalculation> | null;
  ResourceCategories_ItemCategory?: Array<ResourceCategory> | null;

  constructor(item?: IItemCategory) {
    if (item) {

      this.ItemCategoryId = item.ItemCategoryId;
      this.ItemCategoryName = item.ItemCategoryName;
      this.Source = item.Source;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.ItemRates_ItemCategory = Helpers.createClassArray(ItemRate, item.ItemRates_ItemCategory);
      this.Items_ItemCategory = Helpers.createClassArray(Item, item.Items_ItemCategory);
      this.ItemSubCategories_ItemCategory = Helpers.createClassArray(ItemSubCategory, item.ItemSubCategories_ItemCategory);
      this.ProjectResourceItems_ItemCategory = Helpers.createClassArray(ProjectResourceItem, item.ProjectResourceItems_ItemCategory);
      this.ProjectResourceItemsRevisions_ItemCategory = Helpers.createClassArray(ProjectResourceItemsRevision, item.ProjectResourceItemsRevisions_ItemCategory);
      this.ResourceCalculations_ItemCategory = Helpers.createClassArray(ResourceCalculation, item.ResourceCalculations_ItemCategory);
      this.ResourceCategories_ItemCategory = Helpers.createClassArray(ResourceCategory, item.ResourceCategories_ItemCategory);
    }
  }
}